/* eslint-disable */
import { useEffect, useRef, useState } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { useTranslation } from "../../locale/useTranslation";
import { EditPageHeader } from "../../components/EditPageHeader";
import { ENTITYNAME, TOAST_TYPES } from "../../framework/constant/constant";
import * as API from "../../framework/API/api";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import { DateOnlyCell } from "../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import DeleteRoundButton from "../../framework/forms/helpercomponents/buttons/DeleteRoundButton";
import { ConfirmDeleteAlert } from "../../ConfirmAlert";
import EditRoundButton from "../../framework/forms/helpercomponents/buttons/EditRoundButton";
import moment from "moment";
import BossDialog from "../../components/BossDialog";
import ToastNotification from "../../components/ToastNotification";
import MyMultiSelect from "../../components/MyMultiSelect";
import { ArrayCell } from "../../framework/forms/helpercomponents/CustomGridCells/ArrayCell";
import CollectionSelection from "../../framework/forms/CollectionSelection";

const SELECTED_FIELD = "selected";

const TargetsEditForm = (props) => {

    const lang = useTranslation();

    const blankDataItem = {
        FromDate: '',
        ToDate: '',
        Channels: [],
        PlayCount: 0
    }
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [showTargetForm, setShowTargetForm] = useState(false);
    const [isMultiEdit, setIsMultiEdit] = useState(false);
    const [fieldsToUpdate, setFieldsToUpdate] = useState({
        Channels: false,
        PlayCount: false,
        FromDate: false,
        ToDate: false
    });
    const [channels, setChannels] = useState([]);
    const [gridData, setGridData] = useState(props?.targetData ?? []);
    const [isChannelWiseAllocation, setIsChannelWiseAllocation] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [selectedState, setSelectedState] = useState({});
    const [showChannelGroups, setShowChannelGroups] = useState(false);

    const selectedIndexRef = useRef(0);
    const setSelectedIndexRef = (data) => {
        selectedIndexRef.current = data;
    }

    const selectedItemsRef = useRef([]);
    const setSelectedItems = (items) => {
        selectedItemsRef.current = items;
    }

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        let channelRes = await API.getDataLookup(ENTITYNAME.Channel, { sort: { Name: 1 } });
        setChannels(channelRes.data);
    }

    const onChange = (e) => {
        if (e.target.name == "PlayViaPlayCount") {
            setDataItem({ ...dataItem, PlayViaPlayCount: !dataItem.PlayViaPlayCount });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const isValid = () => {
        if (isMultiEdit && !Object.values(fieldsToUpdate).some(v => v)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please select at least one field to update" });
            return false;
        }
        if ((!isMultiEdit || fieldsToUpdate.Channels) && (!dataItem.Channels || dataItem.Channels.length == 0)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
            return false;
        }
        if ((!isMultiEdit || fieldsToUpdate.PlayCount) && dataItem.PlayCount <= 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_correct_play_count_error_message });
            return false;
        }
        if ((!isMultiEdit || fieldsToUpdate.FromDate) && (dataItem.FromDate == undefined || dataItem.FromDate == "")) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_from_date_error_message });
            return false;
        }
        if ((!isMultiEdit || fieldsToUpdate.ToDate) && (dataItem.ToDate == undefined || dataItem.ToDate == "")) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_to_date_error_message });
            return false;
        }
        if (!isMultiEdit && (dataItem.ToDate < dataItem.FromDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.from_date_should_be_less_than_to_date_error_message });
            return false;
        }
        if (isMultiEdit && fieldsToUpdate.FromDate && fieldsToUpdate.ToDate && (dataItem.ToDate < dataItem.FromDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.from_date_should_be_less_than_to_date_error_message });
            return false;
        }
        return true;
    }

    const handleSubmit = () => {
        if (!isValid()) return;

        if (isMultiEdit) {
            const local = [...gridData];
            Object.keys(selectedState).forEach((key) => {
                if (selectedState[key]) {
                    const idx = Number(key);
                    if (fieldsToUpdate.Channels) {
                        local[idx].Channels = dataItem?.Channels?.map(x => ({
                            _id: x._id,
                            SID: x.SID,
                            FullChannelName: x.FullChannelName
                        })) || [];
                    }
                    if (fieldsToUpdate.PlayCount) {
                        local[idx].PlayCount = parseInt(dataItem?.PlayCount);
                    }
                    if (fieldsToUpdate.FromDate) {
                        local[idx].FromDate = new Date(dataItem?.FromDate).getTime();
                    }
                    if (fieldsToUpdate.ToDate) {
                        local[idx].ToDate = new Date(dataItem?.ToDate).getTime();
                    }
                }
            });
            setGridData(local);
            props?.setTargetData(local);
            onClose();
            return;
        }

        const baseData = {
            FromDate: new Date(dataItem?.FromDate).getTime(),
            ToDate: new Date(dataItem?.ToDate).getTime(),
            PlayCount: parseInt(dataItem?.PlayCount),
        };

        let records = [];

        if (isChannelWiseAllocation) {
            records = dataItem?.Channels?.map(channel => ({
                ...baseData,
                Channels: [{
                    _id: channel._id,
                    SID: channel.SID,
                    FullChannelName: channel.FullChannelName
                }]
            }));
        } else {
            records = [{
                ...baseData,
                Channels: dataItem?.Channels?.map(x => ({
                    _id: x._id,
                    SID: x.SID,
                    FullChannelName: x.FullChannelName
                })) || []
            }];
        }

        if (editMode) {
            const local = [...gridData];

            if (isChannelWiseAllocation) {
                local.splice(selectedIndexRef.current, 1, ...records);
            } else {
                local[selectedIndexRef.current] = records[0];
            }

            setGridData(local);
            props?.setTargetData(local);
        } else {
            const updatedData = [...gridData, ...records];
            setGridData(updatedData);
            props?.setTargetData(updatedData);
        }

        onClose();
    };

    const onClose = () => {
        setEditMode(false);
        setShowTargetForm(false);
        setDataItem(blankDataItem);
        setIsChannelWiseAllocation(false);
        setIsMultiEdit(false);
        setSelectedIndexRef(0);
        setSelectedItems([]);
        setSelectedState({});
        setFieldsToUpdate({
            Channels: false,
            PlayCount: false,
            FromDate: false,
            ToDate: false
        });
    }

    const onEdit = (props) => {
        let data = {
            ...props.dataItem,
            FromDate: moment(new Date(props?.dataItem?.FromDate)).format('YYYY-MM-DD'),
            ToDate: moment(new Date(props?.dataItem?.ToDate)).format('YYYY-MM-DD')
        }
        setSelectedIndexRef(props.dataIndex);
        setDataItem(data);
        setEditMode(true);
        setShowTargetForm(true);
    }

    const deleteSelectedValue = (index) => {
        let removeData = [...gridData.slice(0, index), ...gridData.slice(index + 1, gridData.length)]
        setGridData(removeData);
        props?.setTargetData(removeData);
    }

    const MyCommandCell = (props) => {
        return (
            <td>
                <EditRoundButton onClick={() => onEdit(props)} />
                <DeleteRoundButton title={lang.delete_all_button_tooltip} onClick={() => ConfirmDeleteAlert(() => deleteSelectedValue(props.dataIndex), () => { })} />
            </td>
        );
    };

    const deleteAllData = () => {
        setGridData([]);
        props?.setTargetData([]);
    }

    const onSelectionChange = (event) => {
        const index = event.dataItem.rowIndex;
        const newState = {
            ...selectedState,
            [index]: !selectedState[index]
        };
        setSelectedState(newState);
        const selectedItems = gridData.filter(
            (_, idx) => newState[idx]
        );
        setSelectedItems(selectedItems);
    };

    const onHeaderSelectionChange = (event) => {
        const checked = event.syntheticEvent.target.checked;
        const newState = {};
        gridData.forEach((_, index) => {
            newState[index] = checked;
        });
        setSelectedState(newState);
        setSelectedItems(checked ? [...gridData] : []);
    };

    const handleChannelGroups = (groups = []) => {
        const linkedChannels = groups.flatMap(g => g.LinkedChannels || []);

        const uniqueChannels = Array.from(
            new Map(linkedChannels.map(ch => [ch._id, ch])).values()
        );

        setDataItem(prev => ({
            ...prev,
            Channels: uniqueChannels
        }));

        setShowChannelGroups(false);
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <RoundButton onClick={() => setShowTargetForm(true)} />
                    <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => deleteAllData([]), () => { })} />
                    {selectedItemsRef.current.length > 1 && <RoundButton onClick={() => { setShowTargetForm(true); setIsMultiEdit(true); }} icon="pencil" />}
                    <Grid
                        resizable={true}
                        style={{ height: "calc(100vh - 420px)", marginBottom: '15px' }}
                        data={gridData.map((item, index) => ({
                            ...item,
                            rowIndex: index,
                            [SELECTED_FIELD]: selectedState[index]
                        }))}
                        selectedField={SELECTED_FIELD}
                        selectable={{
                            enabled: true,
                            drag: false,
                            cell: false,
                            mode: "multiple",
                        }}
                        onSelectionChange={onSelectionChange}
                        onHeaderSelectionChange={onHeaderSelectionChange}
                        dataItemKey="rowIndex"
                    >
                        <GridColumn
                            field={SELECTED_FIELD}
                            width="50px"
                            headerSelectionValue={
                                gridData.length > 0 &&
                                gridData.every((_, index) => selectedState[index])
                            }
                            locked={true}
                            filterable={false}
                        />
                        <GridColumn cell={MyCommandCell} width={100} />
                        <GridColumn field="Channels" title={lang.channel_column} cell={ArrayCell} format="FullChannelName" />
                        <GridColumn field="PlayCount" title={lang.play_count_column} />
                        <GridColumn field="FromDate" title={lang.from_date_column} cell={DateOnlyCell} />
                        <GridColumn field="ToDate" title={lang.to_date_column} cell={DateOnlyCell} />
                    </Grid>
                </div>
            </div>
            {showTargetForm &&
                <BossDialog title={lang.targets_label} onClose={onClose} width="40%">
                    <div className="d-flex align-items-center w-100">
                        <div>
                            <EditPageHeader showTitle={false} onSubmit={handleSubmit} onCancel={onClose} />
                        </div>

                        {!isMultiEdit && dataItem.Channels.length > 1 && (
                            <div className="d-flex align-items-center ms-auto">
                                <input
                                    type="checkbox"
                                    value={isChannelWiseAllocation}
                                    checked={isChannelWiseAllocation}
                                    onChange={() => setIsChannelWiseAllocation(!isChannelWiseAllocation)}
                                />
                                <label className="ms-1 mb-0 ml-1 mt-1" style={{ fontWeight: 'bold' }}>
                                    Channel-wise Allocation
                                </label>
                            </div>
                        )}
                    </div>
                    <div className="row mt-2">
                        <div className="col-6">
                            <div className="d-flex align-items-center mb-1">
                                <label htmlFor={isMultiEdit ? "chk-channels" : undefined} className="mb-0">
                                    {lang.channels_label} {(!isMultiEdit || fieldsToUpdate.Channels) && " *"}
                                </label>
                                {isMultiEdit && (
                                    <input
                                        type="checkbox"
                                        checked={fieldsToUpdate.Channels}
                                        onChange={(e) => setFieldsToUpdate({ ...fieldsToUpdate, Channels: e.target.checked })}
                                        className="ms-2 ml-2"
                                        id="chk-channels"
                                    />
                                )}
                            </div>
                            <div className="d-flex align-items-center">
                                <div style={{ flex: 1 }}>
                                    <MyMultiSelect
                                        style={{ backgroundColor: (isMultiEdit && !fieldsToUpdate.Channels) ? '#e9ecef' : 'white' }}
                                        data={channels}
                                        textField="FullChannelName"
                                        dataItemKey="_id"
                                        name="Channels"
                                        value={dataItem.Channels}
                                        onChange={onChange}
                                        disabled={isMultiEdit && !fieldsToUpdate.Channels}
                                    />
                                </div>
                                <button
                                    type="button"
                                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-success ms-2"
                                    style={{ width: "28px", height: "28px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginLeft: "10px" }}
                                    title={lang.select_channel_groups_tooltip}
                                    onClick={() => setShowChannelGroups(true)}
                                >
                                    <i className="fa fa-ellipsis-h" aria-hidden="true" />
                                </button>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="d-flex align-items-center mb-1">
                                <label htmlFor={isMultiEdit ? "chk-playcount" : undefined} className="mb-0">
                                    {lang.play_count_label} {(!isMultiEdit || fieldsToUpdate.PlayCount) && " *"}
                                </label>
                                {isMultiEdit && (
                                    <input
                                        type="checkbox"
                                        checked={fieldsToUpdate.PlayCount}
                                        onChange={(e) => setFieldsToUpdate({ ...fieldsToUpdate, PlayCount: e.target.checked })}
                                        className="ms-2 ml-2"
                                        id="chk-playcount"
                                    />
                                )}
                            </div>
                            <input
                                type="number"
                                name="PlayCount"
                                className="form-control form-control-sm"
                                value={dataItem.PlayCount}
                                onChange={onChange}
                                disabled={isMultiEdit && !fieldsToUpdate.PlayCount}
                            />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-6">
                            <div className="d-flex align-items-center mb-1">
                                <label htmlFor={isMultiEdit ? "chk-fromdate" : undefined} className="mb-0">
                                    {lang.from_date_column} {(!isMultiEdit || fieldsToUpdate.FromDate) && " *"}
                                </label>
                                {isMultiEdit && (
                                    <input
                                        type="checkbox"
                                        checked={fieldsToUpdate.FromDate}
                                        onChange={(e) => setFieldsToUpdate({ ...fieldsToUpdate, FromDate: e.target.checked })}
                                        className="ms-2 ml-2"
                                        id="chk-fromdate"
                                    />
                                )}
                            </div>
                            <input
                                type="date"
                                name="FromDate"
                                className="form-control form-control-sm"
                                value={dataItem.FromDate}
                                onChange={onChange}
                                disabled={isMultiEdit && !fieldsToUpdate.FromDate}
                            />
                        </div>
                        <div className="col-6">
                            <div className="d-flex align-items-center mb-1">
                                <label htmlFor={isMultiEdit ? "chk-todate" : undefined} className="mb-0">
                                    {lang.to_date_column} {(!isMultiEdit || fieldsToUpdate.ToDate) && " *"}
                                </label>
                                {isMultiEdit && (
                                    <input
                                        type="checkbox"
                                        checked={fieldsToUpdate.ToDate}
                                        onChange={(e) => setFieldsToUpdate({ ...fieldsToUpdate, ToDate: e.target.checked })}
                                        className="ms-2 ml-2"
                                        id="chk-todate"
                                    />
                                )}
                            </div>
                            <input
                                type="date"
                                name="ToDate"
                                className="form-control form-control-sm"
                                value={dataItem.ToDate}
                                onChange={onChange}
                                disabled={isMultiEdit && !fieldsToUpdate.ToDate}
                            />
                        </div>
                    </div>
                </BossDialog>
            }
            {showChannelGroups && <CollectionSelection setDataList={handleChannelGroups} closeForm={() => setShowChannelGroups(false)} entityname={ENTITYNAME.ChannelGroups} width={"50vw"} title={lang.select_channel_groups_collection_header} addButtonTitle={lang.select_collection_button_text} />}
        </>
    )
}

export default TargetsEditForm;